import React__default from 'react';
import { M as MenuItemButton } from '../../../Menu/MenuItem/MenuItemButton-CcDG6zBs.js';

const SplitButtonItem = props => /*#__PURE__*/React__default.createElement(MenuItemButton, props);

export { SplitButtonItem as S };
//# sourceMappingURL=SplitButtonItem-Bwl_svN7.js.map
